import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
    button: {
        justifyContent: 'left',
        '&:hover': {
            color: theme.palette.primary.main,
            backgroundColor: 'initial',
        },
    },
    fitContent: {
        width: 'auto',
    },
    selected: {
        color: theme.palette.primary.main,
    },
    disabledSelected: {
        color: 'rgba(0, 0, 0, 0.38)',
    },
    disabledLabel: {
        opacity: 0.38,
        position: 'relative' as const,
        cursor: 'default',
    },
    paper: {
        marginTop: theme.spacing(4),
    },
    selectedValue: {
        marginTop: theme.spacing(0.375),
    },
    styleOnePaper: {
        borderColor: theme.palette.grey[500],
        boxShadow: '0 0 6px 0 rgba(0, 0, 0, 0.1)',
        overflowX: 'hidden' as const,
    },
    styleOneMenuItem: {
        marginLeft: theme.spacing(-1.25),
    },
    styleOneButton: {
        justifyContent: 'space-between',
        backgroundColor: theme.palette.grey[100],
        '&:hover': {
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.grey[50],
        },
        '&:focus': {
            outline: 'none',
        },
        padding: '10px 10px 10px 15px !important',
        border: 'none',
    },
    styleOneSelected: {
        color: `${theme.palette.primary.main} !important`,
        backgroundColor: theme.palette.grey[50],
    },
    labelContainer: {
        overflowX: 'hidden' as const,
    },
    icon: {
        width: theme.spacing(1.5),
        height: theme.spacing(1.5),
    },
    menuLabel: {}, // need to override menu styles
    menuItem: {}, // need to override menu styles
    minWidth: {
        minWidth: theme.spacing(7.5),
    },
}));

export const useStyleOnePaperWidth = makeStyles<{ width: number }>()((theme, { width }) => ({
    setWidth: {
        width: `${width}px !important`,
    },
    menuWidth: {
        width: `${width - 2}px !important`,
    },
}));

export const useSelectedLabelWidth = makeStyles<{ labelWidth: number }>()(
    (theme, { labelWidth }) => ({
        maxLabelWidth: {
            maxWidth: `${labelWidth}px !important`,
        },
    }),
);
